import { config as coreConfig } from '@/core/config'

export const config = {
  ...coreConfig,
  apiBaseUrl: new URL(
    window.location.origin + '/api/treatment-plans-api/',
  ).toString(),
  apiRequestTimeout: 1000 * 50, // 50 seconds
} as const
